<template>
    <div>
        <b-dropdown
            dropleft
            no-caret
            ref="dropdown"
            :size="buttonSize"
            variant="secondary"
        >
            <template slot="button-content">
                <div class="d-flex">
                    <div class="mr-2">
                        <b-spinner v-if="isLoading" class="filter-loader" />
                        <img
                            v-else
                            width="17"
                            height="17"
                            src="@/assets/icons/filters.svg"
                        />
                    </div>
                    <span>{{ $t('values.filters') }}</span>
                </div>
            </template>
            <div class="filter-fields">
                <slot :hideContent="hideContent" />
                <div
                    v-if="useDefaultSearchButton"
                    class="d-flex justify-content-end"
                >
                    <b-button
                        :id="btnFilterId"
                        :size="buttonSize"
                        variant="primary"
                        @click="onClickSearch"
                        >{{ $t('form.button.filter') }}</b-button
                    >
                </div>
            </div>
        </b-dropdown>
    </div>
</template>
<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        buttonSize: {
            type: String,
            default: 'md',
        },
        useDefaultSearchButton: {
            type: Boolean,
            default: false,
        },
        btnFilterId: {
            type: String,
            required: false,
            default: 'btn-filter',
        },
    },
    methods: {
        onClickSearch() {
            this.$emit('search')
            this.hideContent()
        },
        hideContent() {
            this.$refs.dropdown.hide(true)
        },
    },
}
</script>
<style scoped>
.filter-fields {
    overflow: auto;
    padding: 20px;
    max-height: 500px;
    width: 500px;
}

.filter-loader {
    color: #696969;
    width: 17px;
    height: 17px;
}
</style>
